<template>
  <div class="container-fluid">
    <div class="loading" v-if="loading">Loading&hellip;</div>

    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">IVA Ventas</h1>
          <p class="view-header__subtitle">Resumen del IVA débito fiscal por alícuota.</p>
        </div>
      </div>
    </div>

    <!-- STATS PRINCIPALES -->
    <div class="row">
      <div class="col-12 col-md-4">
        <div class="stats-card">
          <div class="stats-card__value">{{ formatoDinamicoMoneda(subtotal) }}</div>
          <div class="stats-card__label">Total neto gravado</div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="stats-card">
          <div class="stats-card__value">{{ formatoDinamicoMoneda(tax) }}</div>
          <div class="stats-card__label">Total IVA</div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="stats-card">
          <div class="stats-card__value">{{ formatoDinamicoMoneda(total) }}</div>
          <div class="stats-card__label">Total ventas</div>
        </div>
      </div>
    </div>

    <!-- DESGLOSE POR ALÍCUOTA -->
    <div class="form-card">
      <div class="form-card__header">
        <h6 class="form-card__title">
          <i class="bi bi-percent"></i>
          Desglose por alícuota
        </h6>
      </div>
      <div class="form-card__body">
        <div class="iva-grid">
          <div class="iva-tile">
            <div class="iva-tile__value">{{ formatoDinamicoMoneda(tax25) }}</div>
            <div class="iva-tile__label">IVA 2,5%</div>
          </div>
          <div class="iva-tile">
            <div class="iva-tile__value">{{ formatoDinamicoMoneda(tax50) }}</div>
            <div class="iva-tile__label">IVA 5%</div>
          </div>
          <div class="iva-tile">
            <div class="iva-tile__value">{{ formatoDinamicoMoneda(tax105) }}</div>
            <div class="iva-tile__label">IVA 10,5%</div>
          </div>
          <div class="iva-tile">
            <div class="iva-tile__value">{{ formatoDinamicoMoneda(tax210) }}</div>
            <div class="iva-tile__label">IVA 21%</div>
          </div>
          <div class="iva-tile">
            <div class="iva-tile__value">{{ formatoDinamicoMoneda(tax270) }}</div>
            <div class="iva-tile__label">IVA 27%</div>
          </div>
          <div class="iva-tile">
            <div class="iva-tile__value">{{ formatoDinamicoMoneda(ewivaamount) }}</div>
            <div class="iva-tile__label">Retención IVA</div>
          </div>
          <div class="iva-tile">
            <div class="iva-tile__value">{{ formatoDinamicoMoneda(ewamount) }}</div>
            <div class="iva-tile__label">Retención ganancias</div>
          </div>
        </div>
      </div>
    </div>

    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <q-select v-model="invoiceType" :options="invoiceTypeOptions" />
          </div>
          <div class="filters-panel__field">
            <q-select v-model="selectedPos" :options="posOptions" placeholder="Todos los puntos de venta" />
          </div>
          <div class="filters-panel__field filters-panel__field--inline">
            <label class="control-label">Fecha:</label>
            <Daterange
              :opendir="'left'"
              :initial-start="startDate"
              :initial-end="endDate"
              @datepicked="dateCreated"
            />
          </div>
          <div class="filters-panel__actions">
            <button type="button" class="filters-panel__btn" @click="exportCSV">
              <i class="bi bi-filetype-csv"></i>
              Exportar CSV
            </button>
            <button type="button" class="filters-panel__btn" @click="exportPDF">
              <i class="bi bi-filetype-pdf"></i>
              Exportar PDF
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- TABLA -->
    <div class="data-table">
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="opts"
        :selectCheckbox="0"
        container-class-name="table-responsive"
        class-name="table mb-0"
      />
    </div>
  </div>
</template>

<script>
import VdtnetTable from '@/components/global/VdtnetTable.vue';
import Daterange from "../global/Daterange-component.vue";
import formatMoneyMixin from "../../mixins/formatMoneyMixin";
import formatDateMixin from "../../mixins/formatDateMixin";
import QSelect from '@/components/shared/QSelect.vue';

export default {
  components: {
    VdtnetTable,
    Daterange,
    QSelect,
  },
  mixins: [formatMoneyMixin, formatDateMixin],
  data: function () {
    return {
      loading: false,
      posList: [],
      selectedPos: null,
      invoiceType: "",
      startDate: null,
      endDate: null,
      subtotal: null,
      ewamount: null,
      ewivaamount: null,
      tax25: null,
      tax50: null,
      tax105: null,
      tax210: null,
      tax270: null,
      tax: null,
      total: null,
      opts: {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
        ajax: {
          url: process.env.VUE_APP_BASE_URL + "/api/reports/ivasales",
          type: "GET",
          data: (d) => {
            d.invoiceType = this.invoiceType;
            d.pos_id = this.selectedPos;
            d.daterange = this.daterange;
            return d;
          },
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        },
        processing: true,
        pageLength: 15,
        searching: true,
        searchDelay: 400,
        destroy: true,
        order: [[0, 'desc']],
        ordering: true,
        lengthChange: true,
        serverSide: true,
        autoWidth: false,
      },
      fields: {
        dateHour: {
          label: "Fecha",
          searchable: true,
          render: (data) => this.formatoFechaHora(data),
        },
        receipt: { label: "Comprobante" },
        client_name: {
          label: "Cliente",
          render: (data, type) =>
            type === 'display' ? `<span class="data-table__primary">${data || ''}</span>` : data,
        },
        client_cuit: { label: "CUIT" },
        nettaxed: {
          label: "Neto gravado",
          searchable: true,
          align: "right",
          render: this.formatoDinamicoMoneda,
        },
        iva25: { label: "2,5%", align: "right", render: this.formatoDinamicoMoneda },
        iva50: { label: "5%", align: "right", render: this.formatoDinamicoMoneda },
        iva105: { label: "10,5%", align: "right", render: this.formatoDinamicoMoneda },
        iva210: { label: "21%", align: "right", render: this.formatoDinamicoMoneda },
        iva270: { label: "27%", align: "right", render: this.formatoDinamicoMoneda },
        total: { label: "Total", align: "right", render: this.formatoDinamicoMoneda },
      },
    };
  },
  computed: {
    invoiceTypeOptions() {
      return [
        { value: '', label: 'Todos los tipos' },
        { value: 'FC', label: 'FC' },
        { value: 'NC', label: 'NC' },
        { value: 'ND', label: 'ND' },
      ];
    },
    posOptions() {
      return this.visiblePosList.map(pos => ({ value: pos.id, label: `${pos.branchoffice.name} - ${pos.number}` }));
    },
    visiblePosList() {
      // Los POS con número 0 son placeholders sin configurar — no los mostramos.
      return this.posList.filter((pos) => Number(pos.number) !== 0);
    },
    daterange() {
      if (this.startDate === null || this.endDate === null) return null;
      const startDate = this.formatoFecha2Daterange(this.startDate);
      const endDate = this.formatoFecha2Daterange(this.endDate);
      return `${startDate} - ${endDate}`;
    },
    filters() {
      return {
        invoiceType: this.invoiceType,
        pos_id: this.selectedPos,
        daterange: this.daterange,
      };
    },
  },
  watch: {
    filters() {
      this.refreshTable();
      this.getTotals();
    },
  },
  mounted() {
    this.setDefaultDateRange();
    this.loadSalepoints();
    this.getTotals();
  },
  methods: {
    refreshTable() {
      if (this.$refs.table !== undefined) this.$refs.table.reload();
    },
    dateCreated(date) {
      this.startDate = date.startDate;
      this.endDate = date.endDate;
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      return `${day}/${month}/${year}`;
    },
    setDefaultDateRange() {
      const today = new Date();
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      this.startDate = this.formatDate(startOfMonth);
      this.endDate = this.formatDate(today);
    },
    loadSalepoints() {
      this.$http.get('/api/configs/pos/list')
        .then((response) => {
          if (response.data.success) {
            this.posList = response.data.data;
          }
        })
        .catch((error) => {
          console.error('loadSalepoints:', error);
        });
    },
    getTotals() {
      this.loading = true;
      this.$http.get("/api/reports/statsivasales", { params: this.filters })
        .then((response) => {
          const d = response.data.data;
          this.subtotal = d.subtotal;
          this.ewamount = d.ewamount;
          this.ewivaamount = d.ewivaamount;
          this.tax25 = d.tax25;
          this.tax50 = d.tax50;
          this.tax105 = d.tax105;
          this.tax210 = d.tax210;
          this.tax270 = d.tax270;
          this.tax = d.tax;
          this.total = d.total;
        })
        .catch((error) => {
          console.error('getTotals:', error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    exportCSV() {
      this.$http.post("/api/reports/CSVsaleIVA", this.filters);
    },
    exportPDF() {
      this.$http.post("/api/reports/PDFsaleIVA", this.filters);
    },
  },
};
</script>

<style scoped>
.filters-panel__field--inline {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filters-panel__field--inline .control-label {
  margin: 0;
  white-space: nowrap;
  font-size: 13px;
  color: var(--text);
}

.filters-panel__field--inline > .form-group {
  flex: 1 1 auto;
  margin-bottom: 0;
}

.iva-grid {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
}

.iva-grid > .iva-tile {
  flex: 1 1 0;
  min-width: 0;
}

@media (max-width: 767px) {
  .iva-grid {
    flex-wrap: wrap;
  }

  .iva-grid > .iva-tile {
    flex: 1 1 calc(50% - 4px);
  }
}

.iva-tile {
  text-align: center;
  padding: 12px 8px;
  border-radius: 8px;
  background: var(--surface-subtle);
  border: 1px solid var(--border-soft);
}

.iva-tile__value {
  font-size: 18px;
  font-weight: 700;
  color: var(--text);
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.iva-tile__label {
  font-size: 11px;
  color: var(--text-muted);
  margin-top: 4px;
  font-weight: 500;
}
</style>
